module.exports = __webpack_public_path__ + "img/index_group3.8cb8659b.png";